skrilla.controller('usersCtrl', function ($scope, cacheService, modalService, searchService, queryService,
                                          constantsService, srefService) {

    $scope.tabs = [
        {title: "Completed Users", active: true},
        {title: "Incomplete Users", active: false}
    ];

    $scope.pageKey = constantsService.getUsersPageKey();
    $scope.users = cacheService.getObjectOrElse("usersTable" + $scope.pageKey, []);

    $scope.haveUsers = function(){
        return $scope.tableData.data.length > 0
    }

    $scope.createPromotionCode = function(){
        modalService.openModal("views/createPromotionCodeModal/createPromotionCodeModal.html", true, 'lg', true, true, function(){
        });
    }
    $scope.attemptUserVerification = function(){
        const query = queryService.normaliseQueryObject(cacheService.getObject("queryUsers"));
        modalService.confirm("Are you sure you'd like to attempt to verify these users against our KYC provider?", function(){
            const request = {
                actions: ["Attempt User Verification"],
                query: query
            };
            searchService.post("users/updates", request, "User Verification Attempted!");
        });
    }

    function clickRow(user) {
        srefService.go("userDetails", {id: user.id});
    }

    let tableDataColumns = [
        {title: "Id", field: "id"},
        {title: "Username", field: "username", isUsernameLink: true, tags: "tags"},
        {title: "Full Name", field: "fullName"},
        {title: "Email", field: "email"},
        {title: "Phone", field: "phone"},
        {title: "Country", field: "country"},
        {title: "Date of Birth", field: "dateOfBirth", filter:{name: 'dateTimeFormatter'}},
        {title: "Verification", field: "verificationStatus"},
        {title: "Status", field: "status"},
        {title: "Signed Up", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
        {title: "Role Name", field: "roleName"},
        {title: "Tags", field: "tags"},
        {title: "Currency", field: "fiatCurrency"},
        {title: "Marketing Category", field: "marketingCategory"},
        {title: "Lifetime Revenue", field: "lifetimeRevenue", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
        {title: "Client Number", field: "clientNumber"},
    ]

    // columns to show on users page search result
    let searchResultFields = [
        "username", "fullName", "email", "phone", "country", "dateOfBirth", "verificationStatus",
        "createdAt", "marketingCategory", "lifetimeRevenue"
    ]

    $scope.tableData = {
        columns: tableDataColumns.filter(function (row) {
            return searchResultFields.includes(row.field)
        }),
        rows: {orderBy: "-createdAt", onClick: clickRow},
        isSkrillaTable: true,
        data: $scope.users
    }

    $scope.getCsvData = function () {
        return {
            rows: {orderBy: "-createdAt", onClick: clickRow},
            isSkrillaTable: true,
            columns: tableDataColumns,
            data: $scope.tableData.data
        }
    }

});

